
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { getNews } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  goMiNi() {
    // this.$router.push('empty');
    window.location.href = 'https://appwxsmad5a1601.h5.xiaoeknow.com/p/decorate/page/eyJpZCI6NDA4NjYzMCwiY2hhbm5lbF9pZCI6IiJ9?share_user_id=u_636672bca5c44_BkjBsWTTph&share_type=5&wework_share_customer_id=u_636672bca5c44_BkjBsWTTph&entry=2&entry_type=2002';
  }
  onLoad() {
    getNews(this.page, '全部', '10024').then((res: any) => {
      // getNews(this.page, '全部', '1').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode === 404) {
      this.finished = true;
    } else {
      if (!res.data.data || res.data.data.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.data[0].list];
        }
      }
    }
    this.loading = false;
  }
}
